export default class ErrorMessage {
    private readonly mTitle: string | null;
    private readonly mDescription: string | null;
    private readonly mGeneralErrors: string[];
    private readonly mDetailErrors: string[] | null;
    private readonly mCorrelationId: string | null;

    public constructor(
        title: string | null,
        description: string | null,
        generalErrors: string[] = [],
        detailErrors: string[] | null = null,
        correlationId: string | null = null,
    ) {
        this.mTitle = title;
        this.mDescription = description;
        this.mGeneralErrors = generalErrors;
        this.mDetailErrors = detailErrors;
        this.mCorrelationId = correlationId;
    }

    get title(): string | null {
        return this.mTitle;
    }

    get description(): string | null {
        return this.mDescription;
    }

    get detailErrors(): string[] | null {
        return this.mDetailErrors;
    }

    get correlationId(): string | null {
        return this.mCorrelationId;
    }

    public asArray(): string[] {
        const messages: string[] = Object.assign([], this.mGeneralErrors);

        if (this.title) {
            messages.push(this.title);
        }

        if (this.description) {
            messages.push(this.description);
        }

        return messages;
    }
}
